module.exports = __webpack_public_path__ + "static/media/overpass-extralight-italic.b4ac9dd8.woff";